module.exports = __webpack_public_path__ + "media/images/eyecatch-instagram-review-mockup-a21c6551379ff91611a261b51e7b2697.png";